export const footer = {
tagline: 'Wellness • Personal Care • Direct Sales',
company: 'Company',
legal: 'Legal',
connect: 'Connect',
rights: '\u00a9 2026 One More Global Inc. All rights reserved.',
address: '8556 Katy Freeway, Suite 120, Houston, TX 77024',
};
